// removed by extract-text-webpack-plugin
module.exports = {"message":"src-components-SubscribeBox----index-module---message---3sdi_","error":"src-components-SubscribeBox----index-module---error---1qV4P","sending":"src-components-SubscribeBox----index-module---sending---34U0x","success":"src-components-SubscribeBox----index-module---success---2Rxyg","subscribeBox":"src-components-SubscribeBox----index-module---subscribeBox---DFVnD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscribeBox/index.module.scss
// module id = 39
// module chunks = 35783957827783 48551294870412 248409978923638